import { init as initSentry, reactRouterV7BrowserTracingIntegration, wrapCreateBrowserRouterV7 } from '@sentry/react';

const sentryLogger = {
    init(config, reactRouterInstrumentations) {
        if (config.environment !== 'production') {
            return null;
        }

        initSentry({
            dsn: 'https://ffa4b3f1f254329df275e6eca2359f4b@o1159603.ingest.us.sentry.io/4508449695006721',
            environment: config.environment || 'staging',
            integrations: [
                reactRouterV7BrowserTracingIntegration(reactRouterInstrumentations)
            ],
            beforeSend(event, hint) {
                const isNonErrorException =
                    event.exception.values[0].value.startsWith('Non-Error exception captured') ||
                    hint.originalException?.message?.startsWith('Non-Error exception captured');

                if (isNonErrorException) {
                    return null;
                }

                return {
                    ...event,
                    tags: {
                        ...event.tags,
                        'transaction_id': window.crypto?.randomUUID?.()
                    }
                };
            },
            tracesSampleRate: 0.1
        });
    },

    sentryCreateBrowserRouter(createBrowserRouter) {
        return wrapCreateBrowserRouterV7(createBrowserRouter);
    }
};

export {
    sentryLogger
};
